import { BrokerWorkspace } from './purchasing/BrokerWorkspace';

// Existing dashboard entry point; legacy broker IDs/accounts are retained by
// the shared purchasing workspace rather than creating a second supplier list.
export default function BrokersTab(){return <BrokerWorkspace/>;}